<script>
</script>

<div>
    <div class="modal" id="addon_hbomax" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-hbomax-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 text-fs-26 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">Max</span>
                        <span class="promo-tag"
                            ><svg class="icon"
                                ><use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-price-tag"
                                ></use></svg
                            >
                            <span>50% de descuento hasta el 31 Octubre</span
                            ></span
                        >
                    </div>
                    <p>
                        Vive el entretenimiento al máximo <br />Los estrenos más
                        esperados, series exclusivas, la UEFA Champions League
                        en vivo, increíble contenido para la familia y mucho
                        más.
                    </p>
                    <div class="addon-actions">
                        <a
                            href="/hbomax"
                            class="pure__button pure__button--primary-outline"
                            target="_blank">Conoce más</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="addon_netflixpremium" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-netflixpremium-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">Netflix Premium</span>
                    </div>
                    <p>
                        Reproduce películas y series de Netflix en 4
                        dispositivos al mismo tiempo y, cuando está disponible
                        en HD y Ultra HD, también descarga títulos hasta en 4
                        dispositivos.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="addon_netflixestandar" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-netflixestandar-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">Netflix Estándar</span>
                    </div>
                    <p>
                        Reproduce películas y series de Netflix en 2
                        dispositivos al mismo tiempo y, cuando está disponible
                        en HD, también descarga títulos hasta en 2 dispositivos.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="addon_blimtv" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-blimtv-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">blim tv</span>
                    </div>
                    <p>
                        Disfruta lanzamientos exclusivos, tus películas y
                        programas favoritos, las series y novelas que te han
                        marcado y los grandes clásicos mexicanos.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="addon_disneyplus" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-disneyplus-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">Disney+</span>
                    </div>
                    <p>
                        Las mejores historias de Disney+, Pixar, Marvel, Star
                        Wars y National Geographic.
                    </p>
                    <div class="addon-actions">
                        <a
                            href="/disneyplus"
                            class="pure__button pure__button--primary-outline"
                            target="_blank">Conoce más</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="addon_vix" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--addon"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
                <div class="modal-thumb">
                    <img
                        src="/assets/img/dummy-img/thumbs/addon-vix-1.jpg"
                        alt=""
                    />
                </div>
                <div class="modal-contents">
                    <div
                        class="h2 fw-semibold d-flex align-items-center justify-content-between sm-flex-flow-column m-b-15"
                    >
                        <span class="sm-m-b-10">ViX Premium</span>
                        <span class="promo-tag"
                            ><svg class="icon"
                                ><use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-price-tag"
                                ></use></svg
                            > <span>Promoción especial</span></span
                        >
                    </div>
                    <p>
                        Plataforma de streaming premium con más contenido en
                        español en el mundo, ofreciendo series originales,
                        estreno de películas exclusivas, noticias 24/7, y
                        deportes premium.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
